/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsCustomBillingResource extends models.RecommendationBaseForFinopsCustomResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsCustomBillingResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsCustomBillingResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsCustomBillingResource>): RecommendationForFinopsCustomBillingResource {
        let obj = Object.assign(new RecommendationForFinopsCustomBillingResource(), model);
        RecommendationForFinopsCustomBillingResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsCustomBillingResource>): RecommendationForFinopsCustomBillingResource {
        if (!model) return null;
        return RecommendationForFinopsCustomBillingResource.newInstance(<RecommendationForFinopsCustomBillingResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsCustomBillingResource) {
        if (!obj) return;

        models.RecommendationForFinopsCustomBillingResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsCustomBillingResource): boolean {
        if (models.RecommendationBaseForFinopsCustomResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsCustomBillingResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
